import {
	createContext,
	type ReactNode,
	type RefObject,
	useContext,
	useEffect,
	useRef,
} from "react";

const UnsavedChangesContext = createContext<RefObject<boolean> | null>(null);

export const UnsavedChangesProvider = ({
	children,
}: {
	children: ReactNode;
}) => (
	<UnsavedChangesContext value={useRef(false)}>
		{children}
	</UnsavedChangesContext>
);

export const useHasUnsavedChanges = () => useContext(UnsavedChangesContext);

/** A router supports one blocker, so pages report unsaved changes to ScopeChangeGuard instead of calling `useBlocker`. */
export const useReportUnsavedChanges = (hasUnsavedChanges: boolean) => {
	const unsavedChanges = useContext(UnsavedChangesContext);
	useEffect(() => {
		if (!unsavedChanges) return;
		unsavedChanges.current = hasUnsavedChanges;
		return () => {
			unsavedChanges.current = false;
		};
	}, [unsavedChanges, hasUnsavedChanges]);
};
